import { convertLength } from '@turf/turf';

/**
 * Converts elevation from one unit to another.
 * @param elevation
 * @param from Strava uses meters
 * @param to unit to convert to
 * @returns
 */
export function convertElevation(
  elevation: number,
  from: 'meters',
  to: 'meters' | 'feet',
) {
  if (from === to) {
    return elevation;
  }
  try {
    const sign = elevation < 0 ? -1 : 1;
    return convertLength(Math.abs(elevation), from, to) * sign;
  } catch (error) {
    console.error(error);
    return elevation;
  }
}
